export default function HeroSection() {
  const stats = [
    { label: '每日更新', value: '200+', desc: '条最新爆料' },
    { label: '内容覆盖', value: '15+', desc: '个热门版块' },
    { label: '即时直达', value: '7×24', desc: '小时不间断' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[640px] flex items-center overflow-hidden bg-background-50"
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-96 h-96 rounded-full bg-primary-100/30 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full bg-accent-100/20 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-6xl mx-auto px-4 md:px-6 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Left - Text content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <span className="inline-block px-3 py-1 mb-4 text-xs font-medium text-primary-600 bg-primary-50 border border-primary-200/60 rounded-full whitespace-nowrap">
              🔥 全网最新黑料吃瓜入口
            </span>

            {/* H1 */}
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight font-heading">
              51黑料吃瓜网
              <br />
              <span className="text-primary-500">全网最新娱乐爆料聚合平台</span>
            </h1>

            {/* Slogan */}
            <p className="mt-3 text-base md:text-lg text-foreground-500 font-medium">
              每日更新黑料吃瓜最新地址，一站式获取全网热门八卦
            </p>

            {/* Description */}
            <p className="mt-4 max-w-xl mx-auto lg:mx-0 text-sm md:text-base text-foreground-600 leading-relaxed">
              51黑料吃瓜网官方入口，每日精选全网最新黑料吃瓜内容，覆盖明星动态、网红八卦、影视综艺、社会热点等多个领域。黑料吃瓜网址一键直达，51吃瓜官网全网最新资源实时更新，吃瓜网站首页持续优化，做最懂你的娱乐资讯聚合平台。
            </p>

            {/* Stats */}
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="text-left">
                    <div className="text-lg md:text-xl font-bold text-primary-500 whitespace-nowrap">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-500 whitespace-nowrap">
                      {stat.label} · {stat.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-line"></i>
                查看热度榜单
              </a>
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-full border border-background-300/60 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-eye-line"></i>
                浏览热门爆料
              </a>
            </div>
          </div>

          {/* Right - Visual */}
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative mx-auto w-full max-w-sm lg:max-w-none aspect-[4/3] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20entertainment%20news%20aggregator%20website%20visual%20with%20warm%20red%20and%20dark%20tones%2C%20glowing%20abstract%20geometric%20shapes%2C%20digital%20media%20elements%2C%20news%20headlines%20floating%20in%20space%2C%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20tech%20and%20media%20aesthetic%2C%20clean%20composition&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="51黑料吃瓜网 - 全网最新娱乐爆料聚合平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
              {/* Dark overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-black/10 to-primary-500/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}